import axios from 'axios';

import { uiAppName } from '@nova/core';

import config from '@/config';

const client = axios.create({
  baseURL: config.neutron_url,
  headers: {
    'X-UI-AppName': uiAppName.JUNO
  }
});

export default client;
